import {
    TPI_PRODUCT,
    TPI_PRODUCT_SUCCESS,
    TPI_PRODUCT_ERROR,
    TPI_SUPPLIER,
    TPI_SUPPLIER_SUCCESS,
    TPI_SUPPLIER_ERROR,
    TPI_DELIVERY_ORDER,
    TPI_DELIVERY_ORDER_SUCCESS,
    TPI_DELIVERY_ORDER_ERROR,
    TPI_STATUS_DOCS,
    TPI_STATUS_DOCS_SUCCESS,
    TPI_STATUS_DOCS_ERROR,
    TPI_LIST,
    TPI_LIST_SUCCESS,
    TPI_LIST_ERROR,
    TPI_LIST_SEARCH_CHANGE,
    TPI_LIST_PAGE_SET,
    TPI_EDIT_MODAL_SET,
    TPI_EDIT_CHANGE_SET,
    TPI_EDIT,
    TPI_EDIT_SUCCESS,
    TPI_EDIT_ERROR,
    TPI_MTO_MODAL_SET,
    TPI_MTO_CHANGE_SET,
    TPI_MTO_DETAIL,
    TPI_MTO_DETAIL_SUCCESS,
    TPI_MTO_DETAIL_ERROR,
    TPI_EDIT_MTO_MODAL_SET,
    TPI_EDIT_MTO_CHANGE_SET,
    TPI_EDIT_MTO,
    TPI_EDIT_MTO_SUCCESS,
    TPI_EDIT_MTO_ERROR,
    TPI_PROJECTION_MAINTENANCE_DATES,
    TPI_PROJECTION_MAINTENANCE_DATES_SUCCESS,
    TPI_PROJECTION_MAINTENANCE_DATES_ERROR,
    TPI_DOCUMENTATION,
    TPI_DOCUMENTATION_SUCCESS,
    TPI_DOCUMENTATION_ERROR
} from "../../actions";


const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    product: {
        loading: false,
        data: []
    },
    supplier: {
        loading: false,
        data: []
    },
    deliveryorder: {
        loading: false,
        data: []
    },
    statusdocs: {
        loading: false,
        data: []
    },
    documentation: {
        loading: false,
        data: []
    },
    edit: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    detailmto: {
        loading: false,
        data: []
    },
    maintenance: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    editmaintenance: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    projectionmaintenancedates: {
        loading: false,
        data: []
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            product: '',
            supplier: '',
            deliveryorder: '',
            serie: '',
            status:''
        },
        value: {
            product: '',
            supplier: '',
            deliveryorder: '',
            serie: '',
            status:''
        }
    }
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case TPI_PRODUCT:
            return {
                ...state,
                loading: true,
                product: {
                    ...state.product
                }
            }
        case TPI_PRODUCT_SUCCESS:
            return {
                ...state,
                loading: false,
                product: {
                    ...state.product,
                    ...action.payload
                }
            }
        case TPI_PRODUCT_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case TPI_SUPPLIER:
            return {
                ...state,
                loading: true,
                supplier: {
                    ...state.supplier
                }
            }
        case TPI_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                supplier: {
                    ...state.supplier,
                    ...action.payload
                }
            }
        case TPI_SUPPLIER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case TPI_DELIVERY_ORDER:
            return {
                ...state,
                loading: true,
                deliveryorder: {
                    ...state.deliveryorder
                }
            }
        case TPI_DELIVERY_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                deliveryorder: {
                    ...state.deliveryorder,
                    ...action.payload
                }
            }
        case TPI_DELIVERY_ORDER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case TPI_STATUS_DOCS:
            return {
                ...state,
                loading: true,
                statusdocs: {
                    ...state.statusdocs
                }
            }
        case TPI_STATUS_DOCS_SUCCESS:
            return {
                ...state,
                loading: false,
                statusdocs: {
                    ...state.statusdocs,
                    ...action.payload
                }
            }
        case TPI_STATUS_DOCS_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case TPI_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }

        case TPI_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case TPI_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case TPI_LIST_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                }
            }
        case TPI_LIST_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case TPI_EDIT_MODAL_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: action.payload
                }
            }
        case TPI_EDIT_CHANGE_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    data: {
                        ...state.edit.data,
                        ...action.payload
                    }
                }
            }
        case TPI_EDIT:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false
                }
            }
        case TPI_EDIT_SUCCESS:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case TPI_EDIT_ERROR:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case TPI_MTO_MODAL_SET:
            return {
                ...state,
                maintenance: {
                    ...state.maintenance,
                    modal: action.payload
                }
            }
        case TPI_MTO_CHANGE_SET:
            return {
                ...state,
                detailmto: {
                    ...state.detailmto,
                    data: {
                        ...state.detailmto.data,
                        ...action.payload
                    }
                }
            }
        case TPI_MTO_DETAIL:
            return {
                ...state,
                loading: true,
                maintenance: {
                    ...state.maintenance
                }
            }
        case TPI_MTO_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                maintenance: {
                    ...state.maintenance,
                    ...action.payload
                }
            }
        case TPI_MTO_DETAIL_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case TPI_EDIT_MTO_MODAL_SET:
            return {
                ...state,
                editmaintenance: {
                    ...state.editmaintenance,
                    modal: action.payload
                }
            }
        case TPI_EDIT_MTO_CHANGE_SET:
            return {
                ...state,
                editmaintenance: {
                    ...state.editmaintenance,
                    data: {
                        ...state.editmaintenance.data,
                        ...action.payload
                    }
                }
            }
        case TPI_EDIT_MTO:
            return {
                ...state,
                editmaintenance: {
                    ...state.editmaintenance,
                    loading: false
                }
            }
        case TPI_EDIT_MTO_SUCCESS:
            return {
                ...state,
                editmaintenance: {
                    ...state.editmaintenance,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                maintenance: {
                    ...state.maintenance,
                    ...action.payload
                }
            }
        case TPI_EDIT_MTO_ERROR:
            return {
                ...state,
                editmaintenance: {
                    ...state.editmaintenance,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case TPI_PROJECTION_MAINTENANCE_DATES:
            return {
                ...state,
                loading: true,
                projectionmaintenancedates: {
                    ...state.projectionmaintenancedates
                }
            }
        case TPI_PROJECTION_MAINTENANCE_DATES_SUCCESS:
            return {
                ...state,
                loading: false,
                projectionmaintenancedates: {
                    ...state.projectionmaintenancedates,
                    ...action.payload
                }
            }
        case TPI_PROJECTION_MAINTENANCE_DATES_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case TPI_DOCUMENTATION:
            return {
                ...state,
                loading: true,
                documentation: {
                    ...state.documentation
                }
            }
        case TPI_DOCUMENTATION_SUCCESS:
            return {
                ...state,
                loading: false,
                documentation: {
                    ...state.documentation,
                    ...action.payload
                }
            }
        case TPI_DOCUMENTATION_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        default:
            return { ...state };
    }
};

